module.exports = __webpack_public_path__ + "img/project.5a2bc5fc.jpg";